export async function hashPassword(password) {
    const encoder = new TextEncoder();
    const data = encoder.encode(password);
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
    return hashHex;
}

export const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
};

export const isValidPhone = (phone) => {
    const phoneRegex = /^\d{10}$/;
    return phoneRegex.test(phone);
};

export const isStrongPassword = (password) => {
    // At least 8 chars, 1 uppercase, 1 lowercase, 1 number, 1 special char
    const strongPasswordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    return strongPasswordRegex.test(password);
};

/**
 * GET USER TYPE
 * Returns the type of user based on the JWT token
 */
export const getUserType = (avoidSwitchProfile = false) => {
    const token = localStorage.getItem('authToken');
    const activeProfile = localStorage.getItem('activeProfile');
    if (activeProfile && !avoidSwitchProfile) {
        return activeProfile;
    }
    if (token) {
        const payload = getJwtPayload(token);
        let activeRole = payload?.role?.includes("2") ? "admin" : "guest";
        return activeRole;
    }
    return "guest";
};

/**
 * GET JWT PAYLOAD
 * Gets the payload from a JWT token
 */
export const getJwtPayload = (token) => {
    if (!token || typeof token !== 'string') {
        return null;
    }

    const parts = token.split('.');
    if (parts.length < 2) {
        return null;
    }

    try {
        const base64Url = parts[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');
        const json = atob(padded);
        return JSON.parse(json);
    } catch (error) {
        console.error('Failed to decode JWT payload', error);
        return null;
    }
};